/**
 * Export mode options for booking exports.
 * Determines the scope of bookings included in an export operation.
 */
export default Object.freeze({
  /**
   * Export all bookings matching the current filters and date range.
   * User can configure date range, status filters, and columns to include.
   */
  All: 'all',

  /**
   * Export only the bookings that the user has explicitly selected.
   * Date range is derived from the selected bookings' start/end dates.
   * Status filters are not applied; only the selected booking IDs are exported.
   */
  Selected: 'selected',
})
